import React from "react";

type Props = {
  hexColor: string;
};
const ColorIndicator: React.FC<Props> = ({ hexColor }) => {
  const indicatorStyle = {
    width: "22px",
    height: "22px",
    borderRadius: "50%",
    backgroundColor: hexColor,
    marginLeft: "3px",
    display: "inline-block",
  };

  return (
    <div
      style={indicatorStyle}
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      title={hexColor}
    ></div>
  );
};

export default ColorIndicator;
